import { cn } from "@/lib/utils";

interface FieldInlineErrorProps {
  message?: string;
  id?: string;
  className?: string;
}

/** Inline validation message shown below a form field (P1 consistent pattern). */
export function FieldInlineError({ message, id, className }: Readonly<FieldInlineErrorProps>) {
  if (!message) {
    return null;
  }
  return (
    <p id={id} role="alert" className={cn("text-sm text-red-800 font-medium", className)}>
      {message}
    </p>
  );
}
